/**
 * Archive Search Module: Interactive Search & Filters for All Post Types
 *
 * @package Gina_Theme
 */
(function() {
  'use strict';

  function initArchiveSearch() {
    const searchForm = document.getElementById('archive-search-form');
    if (!searchForm) return;

    const keywordInput = document.getElementById('archive-keyword-input');
    const clearKeywordBtn = document.getElementById('archive-clear-keyword-btn');
    const postTypeInput = document.getElementById('archive-post-type-input');
    const tabBtns = document.querySelectorAll('.archive-tab-btn');
    const taxonomySelects = searchForm.querySelectorAll('.archive-taxonomy-select');

    // ─── 1. Keyword Clear Button ────────────────────────────────────
    if (keywordInput && clearKeywordBtn) {
      keywordInput.addEventListener('input', function() {
        if (keywordInput.value.trim() !== '') {
          clearKeywordBtn.classList.remove('hidden');
        } else {
          clearKeywordBtn.classList.add('hidden');
        }
      });

      clearKeywordBtn.addEventListener('click', function() {
        keywordInput.value = '';
        clearKeywordBtn.classList.add('hidden');
        keywordInput.focus();
      });
    }

    // ─── 2. Switch Tab on Click (Direct Clean Navigation) ─────────
    tabBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        const targetUrl = this.getAttribute('data-archive-url') || this.getAttribute('href');
        if (targetUrl) {
          e.preventDefault();
          window.location.href = targetUrl;
        }
      });
    });

    // ─── 3. Clean Empty Inputs Before Submission ────────────────────
    function cleanFormInputs() {
      const inputs = searchForm.querySelectorAll('input, select');
      inputs.forEach(input => {
        if (input.type !== 'submit' && !input.value.trim()) {
          input.disabled = true;
        }
      });

      // Avoid redundant post_type parameter on dedicated archive pages
      if (postTypeInput) {
        const val = postTypeInput.value;
        const formAction = searchForm.action || '';
        if (
          (val === 'insect' && formAction.includes('/insects')) ||
          (val === 'service' && formAction.includes('/services')) ||
          (val === 'recruitment' && formAction.includes('/recruitment')) ||
          (val === 'post' && !formAction.includes('post_type=post'))
        ) {
          postTypeInput.disabled = true;
        }
      }
    }

    searchForm.addEventListener('submit', function() {
      cleanFormInputs();
    });

    // ─── 4. Auto-Submit on Taxonomy / Category Dropdown Change ──────
    taxonomySelects.forEach(select => {
      select.addEventListener('change', function() {
        cleanFormInputs();
        searchForm.submit();
      });
    });

    // Re-enable all inputs if page restored from bfcache
    window.addEventListener('pageshow', function() {
      const inputs = searchForm.querySelectorAll('input, select');
      inputs.forEach(input => {
        input.disabled = false;
      });
    });
  }

  // Export module to global scope
  window.GinaArchiveSearch = {
    init: initArchiveSearch
  };

})();
